
<script>
import moment from 'moment'
import { mixin as clickaway } from 'vue-clickaway'
import filtersField from '@/components/services/ui/filtersField.vue'
import { nToWord } from '@/utils/helpers'
import { rexTagpicker } from '@/components/views/rexField'
import { rexRoundedDate } from '@/components/views/rexRoundedField'

export default {
  name: 'FavoritesFilters',
  components: {
    rexTagpicker,
    filtersField,
    rexRoundedDate
  },
  mixins: [
    clickaway
  ],
  data: () => ({
    quickFilterButton: {
      isShow: false,
      offsetTop: 0,
    }
  }),
  computed: {
    isLoading() {
      return this.$store.getters['favorites/isLoading']
    },
    isFiltering() {
      return this.$store.getters['favorites/isFiltering']
    },
    isLoadingMore() {
      return this.$store.getters['favorites/isLoadingMore']
    },
    getFields() {
      return this.$store.getters['favorites/getFields']
    },
    filtersCollection() {
      return this.$store.getters['favorites/getCollectionFilters']
    },
    getDaysWithFavorites() {
      return this.filtersCollection.date.map(item => moment.unix(item).toDate())
    },
    isDeleteMode() {
      return this.$store.getters['favorites/isDeleteMode']
    },
    getSelectedItems() {
      return this.$store.getters['favorites/getSelectedItems']
    },
    selectedCountLabel() {
      const count = this.getSelectedItems.length

      const label = nToWord(this.getSelectedItems.length, ['Выбран', 'Выбрано', 'Выбрано'])
      const countLabel = nToWord(count, ['предложение', 'предложения', 'предложений'])

      return `${label}: ${count} ${countLabel}`
    }
  },
  methods: {
    filter() {
      this.quickFilterButton = {
        isShow: false,
        offsetTop: 0
      }

      this.$store.commit('favorites/updateIsFiltersApplied', true)
      this.$store.dispatch('favorites/filterCollection', {
        ...this.$store.getters['favorites/getFields']
      })
    },
    formChangeHandler({ element: { offsetTop } }) {
      this.quickFilterButton = {
        isShow: true,
        offsetTop
      }

      this.$store.commit('favorites/updateIsFiltersApplied', false)
    },
    hideQuickFilterButton() {
      this.quickFilterButton.isShow = false
    },
    getYesterdayDate() {
      return moment(new Date()).add(-1, 'days').toDate()
    },
    removeAll() {
      this.$store.dispatch('favorites/removeAll')
    },
    enableDeleteMode() {
      this.$store.commit('favorites/enableDeleteMode')
    },
    disableDeleteMode() {
      this.$store.commit('favorites/disableDeleteMode')
    },
    removeFavorite() {
      this.$store.dispatch('favorites/removeFavorite', {
        ids: this.getSelectedItems
      })
    }
  }
}
</script>

<template>
  <div
    v-on-clickaway="hideQuickFilterButton"
    class="search-content__filters"
  >
    <b-loading
      :is-full-page="false"
      :active="isLoading"
    />
    <div
      v-if="!isLoading && !isDeleteMode"
      class="search-content__filters-content search-content__filters-content--favorites"
    >
      <a
        v-if="quickFilterButton.isShow"
        :style="{
          'top':`${quickFilterButton.offsetTop}px`
        }"
        href="javascript:;"
        class="rex-rounded-field--btn search-content__filters-quickfilter"
        @click="filter"
      >
        Применить
      </a>
      <filters-field
        label="Поиск"
        :default-open="true"
      >
        <rex-tagpicker
          name="locations"
          placeholder="По отелю, расположению, названию"
          store-module="favorites"
          getter-name="getField"
          setter-name="updateField"
          target="filters.locations"
          :data="filtersCollection.locations"
          @onChange="formChangeHandler"
        />
      </filters-field>
      <filters-field
        label="Дата заезда"
        :default-open="true"
      >
        <rex-rounded-date
          store-module="favorites"
          getter-name="getField"
          setter-name="updateField"
          target="filters"
          :show-label="false"
          :min-date="getYesterdayDate()"
          :range="true"
          position="is-bottom-left"
          range-start-date-name="dateFrom"
          range-end-date-name="dateTo"
          :marks="getDaysWithFavorites"
        />
      </filters-field>
      <div class="search-content__filters-button-wrap">
        <button
          href="javascript:;"
          class="rex-rounded-field--btn "
          @click="filter"
        >
          Фильтровать
        </button>
      </div>
      <p class="search-content__filters-content-helper-text">
        Нажмите «Выбрать туры» и кликните на карточки туров,
        чтобы удалить, скачать или отправить их по почте.
      </p>
      <div class="search-content__filters-button-wrap">
        <a
          href="javascript:;"
          class="rex-rounded-field--btn"
          @click="enableDeleteMode"
        >
          Выбрать туры
        </a>
      </div>
      <div class="sidebar__links">
        <div class="sidebar__links-item">
          <a
            href="javascript:;"
            @click="removeAll"
          >
            Очистить все
          </a>
        </div>
      </div>
      <b-loading
        :is-full-page="false"
        :active="isFiltering || isLoadingMore"
      />
    </div>
    <div
      v-if="!isLoading && isDeleteMode"
      class="search-content__filters-content search-content__filters-content--favorites"
    >
      <p class="search-content__filters-content-counter">
        {{ selectedCountLabel }}
      </p>
      <div class="search-content__filters-button-wrap">
        <button
          v-if="getSelectedItems.length"
          class="rex-rounded-field--btn rex-rounded-field--btn--grey"
          @click="removeFavorite"
        >
          Удалить из избранных
        </button>
        <button
          v-if="getSelectedItems.length"
          class="rex-rounded-field--btn"
        >
          Отправить по почте
        </button>
        <a
          href="javascript:;"
          class="rex-rounded-field--btn rex-rounded-field--btn--bottomed"
        >
          Скачать в pdf
        </a>
        <a
          href="javascript:;"
          class="rex-rounded-field--btn rex-rounded-field--btn--grey"
          @click="disableDeleteMode"
        >
          Назад
        </a>
      </div>
    </div>
  </div>
</template>
